// Shared formatting utilities

// Format Brazilian phone numbers: (DD) 9####-#### or (DD) ####-####
export function formatPhoneBR(input: string): string {
  const digits = (input || '').replace(/\D/g, '').slice(0, 11);
  if (digits.length === 0) return '';
  if (digits.length <= 2) return `(${digits}`;
  if (digits.length <= 6) return `(${digits.slice(0, 2)}) ${digits.slice(2)}`;
  if (digits.length <= 10) {
    // landline: (11) 1234-5678
    return `(${digits.slice(0, 2)}) ${digits.slice(2, 6)}-${digits.slice(6)}`;
  }
  // mobile: (11) 91234-5678
  return `(${digits.slice(0, 2)}) ${digits.slice(2, 7)}-${digits.slice(7)}`;
}

// Normalize Brazilian phone numbers to digits only (max 11 digits)
export function normalizePhone(input: string | null | undefined): string {
  return (input || '').replace(/\D/g, '').slice(0, 11);
}
